import React from 'react';

import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
    selectCartTotal,
    selectCartItemsCount,
    selectToggle,
    selectPageName,
    selectAddOnCheck,
    selectTrainNo,
    selectBoardingStation,
    selectBoardingDate,
    selectPnr,
    selectStations,
    selectStation,
    selectPrice,
    selectleadTime,
    selectUrlData,
} from '../../redux/cart/cart.selector';
import {
    ToggleCart,
    actionAddonCheck,
    setPageName,
    setStationsDetailStart,
    setName,
    setPnr,
    setPhoneNo,
    setCoachNumber,
    setSeatNumber,
    setEmailId,
    checkLeadTimeStart,
    setStationsDetailSuccess,
    setVersion,
    setBulkOrderStart
} from '../../redux/cart/cart.action';
import Cart from '../../components/cart/cart.component';
import JourneyDetails from '../../components/journey-details/journey-details.component';
import PriceLimit from './price-limit.component';

import timeout from '../../assets/timeout-icon.svg';
import loader from '../../assets/loader-icon.svg';

import './sticky.style.css';

class sticky extends React.Component {

    constructor() {
        super();
        this.state = {
            bulkOrder: false
        }

        
    }
    myFunction() {
        var element = document.getElementById("proceednext");
        element.classList.add("loading");
        setTimeout(function() {
            document.getElementById("proceednext").classList.remove("loading");
            document.getElementById("proceednext").disabled = false;
        },5000);
    }
    componentDidMount(){
        if (document.getElementById("proceednext")) {
            let btn = document.getElementById("proceednext");
            btn.className = btn.className.replace("loading", "");
            document.getElementById("proceednext").disabled = false;
        }
    }

    componentWillUnmount() {
        this.setState({ bulkOrder: false });
    }
    proceed = async () => {

        await this.props.addonCheck();
        if (this.props.checkAddOn === true) {
            let btn = document.getElementById("proceednext");
            btn.className = btn.className.replace("loading", "");
            var x = document.getElementById("addontoast");
            x.className = "addontoast show";
            setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
            return;
        }
        else if (this.props.totalItem === 0) {
            let btn = document.getElementById("proceednext");
            btn.className = btn.className.replace("loading", "");
            var y = document.getElementById("noItemToast");
            y.className = "addontoast show";
            setTimeout(function () { y.className = y.className.replace("show", ""); }, 3000);
            return;
        } else {

            if (this.props.pagename === 'Journey Details') {
                this.props.setPage('Station Details');
            } else if (this.props.pagename === 'Station Details') {
                if (this.props.boardingDate === '') {
                    document.getElementById('boarding_date_error').style.display = "block";
                }

                if ((this.props.trainNo === '' || this.props.boardingStation === '') && (this.props.pnr === '')) {
                    if (this.props.trainNo === '') {
                        document.getElementById('train_name_error').style.display = "block";
                    }
                    if (this.props.boardingStation === '') {
                        document.getElementById('station_name_error').style.display = "block";
                    }
                    return;
                }
                if (this.props.pnr !== '') {
                    if (this.props.pnr.length < 10) {
                        document.getElementById('pnr_error').style.display = "block";
                        document.getElementById('pnr_error').textContent = "PNR must be 10 digits";
                        return;
                    }
                    if (this.props.pnr.length > 10) {
                        document.getElementById('pnr_error').style.display = "block";
                        document.getElementById('pnr_error').textContent = "PNR is not valid";
                        return;
                    }

                }
                let btn = document.getElementById("proceednext");
                btn.className = "loading";
                this.props.getStationDetails();
            } else if (this.props.pagename === 'Station List' || this.props.pagename === 'All Station List') {
                let btn = document.getElementById("proceednext");
                btn.className = "loading";
                window.location.href = "/m/buy-food-in-train/review-page"+this.props.urlData

            } else if (this.props.pagename === 'Review Page') {
                this.handleSubmit();
            }
        }

    }

    handleStationToast = (props) => {
        let btn = document.getElementById("proceednext");
        btn.className = btn.className.replace("loading", "");
        var x = document.getElementById("stationontoast");
        if (x) {
            x.className = "addontoast show";
            setTimeout(function () {
                x.className = x.className.replace("show", "");
                props.setStationDetails([])
            }, 3000);
        }
    }

    handleSubmit = async () => {
        var userPhoneNumber = document.getElementById("user_phone_number1").value;
        var userName = document.getElementById("user_name1").value;
        var seatNumber = document.getElementById("seat_number1").value;
        var coachNumber = document.getElementById("coach_number1").value;
        var userEmail = document.getElementById("user_email1").value;
        var userPnr = document.getElementById("user_pnr1").value;
        //var comments = document.getElementById("comments").value;

        this.props.setPhoneNo(userPhoneNumber);
        this.props.setName(userName);
        this.props.setSeatNo(seatNumber);
        this.props.setCoachNo(coachNumber);
        this.props.setEmail(userEmail);
        this.props.setPnr(userPnr);

        var zeroContactDelivery = '';
        //var zeroContactDelivery = document.getElementById("zero-contact-delivery-checkbox").checked;
        //var freebies = document.getElementById("freebies-checkbox").checked;            

        // true or false
        localStorage.setItem("zero_contact_delivery", zeroContactDelivery);
        //localStorage.setItem("freebies", freebies);            


        var isUserPhoneEntered = 1;
        var isUserNameEntered = 1;
        var isSeatNumberEntered = 1;
        var isCoachNumberEntered = 1;
        var isUserEmailEntered = 1;
        var isUserPnrEntered = 1;

        var isUserPhoneValid = 1;
        var isUserNameValid = 1;
        var isSeatNumberValid = 1;
        var isCoachNumberValid = 1;
        var isUserEmailValid = 1;
        var isUserPnrValid = 1;


        if (userPhoneNumber === "") {
            isUserPhoneEntered = 0;
            document.getElementById("user_phone_number1").style.borderColor = "#ff8784";
            document.getElementById("user_phone_number_error1").style.display = "inline-block";
            document.getElementById("user_phone_number_error1").textContent = "Enter phone number";
            document.getElementById("user_phone_number1").scrollIntoView();
        }

        if (userName === "") {
            isUserNameEntered = 0;
            document.getElementById("user_name1").style.borderColor = "#ff8784";
            document.getElementById("user_name_error1").style.display = "inline-block";
            document.getElementById("user_name_error1").textContent = "Enter name";
            document.getElementById("user_phone_number1").scrollIntoView();
        }

        if (seatNumber === "") {
            isSeatNumberEntered = 0;
            document.getElementById("seat_number1").style.borderColor = "#ff8784";
            document.getElementById("seat_number_error1").style.display = "inline-block";
            document.getElementById("seat_number_error1").textContent = "Enter seat number";
            document.getElementById("user_phone_number1").scrollIntoView();
        }

        if (coachNumber === "") {
            isCoachNumberEntered = 0;
            document.getElementById("coach_number1").style.borderColor = "#ff8784";
            document.getElementById("coach_number_error1").style.display = "inline-block";
            document.getElementById("coach_number_error1").textContent = "Enter coach number";
            document.getElementById("user_phone_number1").scrollIntoView();
        }


        if (userEmail === "") {
            isUserEmailEntered = 0;
            document.getElementById("user_email1").style.borderColor = "#ff8784";
            document.getElementById("user_email_error1").style.display = "inline-block";
            document.getElementById("user_email_error1").textContent = "Enter email";
            document.getElementById("user_phone_number1").scrollIntoView();
        }





        // Validating phone number
        isUserPhoneValid = /^\d+$/.test(userPhoneNumber);

        var isPhoneNumber10Digit = 1;

        if (userPhoneNumber.length === 10) {
            isPhoneNumber10Digit = 1;
        } else {
            isPhoneNumber10Digit = 0;
        }


        if ((isPhoneNumber10Digit === 1) && isUserPhoneValid) {

            isUserPhoneValid = true;
        } else {

            isUserPhoneValid = false;
        }



        if (isUserPhoneValid) {
            isUserPhoneValid = 1;

        } else {
            isUserPhoneValid = 0;
            document.getElementById("user_phone_number1").style.borderColor = "#ff8784";
            document.getElementById("user_phone_number_error1").style.display = "inline-block";


            if (isPhoneNumber10Digit === 0) {
                document.getElementById("user_phone_number_error1").textContent = "Phone number must have 10 digits";
            } else {
                document.getElementById("user_phone_number_error1").textContent = "Not valid";
            }

            document.getElementById("user_phone_number1").scrollIntoView();
        }

        // Validating name
        isUserNameValid = /[A-Za-z]+$/.test(userName);

        if (isUserNameValid) {
            isUserNameValid = 1;
        } else {
            isUserNameValid = 0;
            document.getElementById("user_name1").style.borderColor = "#ff8784";
            document.getElementById("user_name_error1").style.display = "inline-block";
            document.getElementById("user_name_error1").textContent = "Name is not valid";
            document.getElementById("user_phone_number1").scrollIntoView();
        }

        // Validating Coach No
        isCoachNumberValid = /([A-Za-z]{1,2})(\d{1,2})$/.test(coachNumber);

        if (isCoachNumberValid) {
            isCoachNumberValid = 1;
        } else {
            isCoachNumberValid = 0;
            document.getElementById("coach_number1").style.borderColor = "#ff8784";
            document.getElementById("coach_number_error1").style.display = "inline-block";
            document.getElementById("coach_number_error1").textContent = "Coach No is not valid";
            document.getElementById("user_phone_number1").scrollIntoView();
        }


        // Validating seat number
        if (/^\d+$/.test(seatNumber)) {

            if ((parseInt(seatNumber) <= 150) && (parseInt(seatNumber) > 0)) {
                isSeatNumberValid = 1;
            } else {
                isSeatNumberValid = 0;
                document.getElementById("seat_number1").style.borderColor = "#ff8784";
                document.getElementById("seat_number_error1").style.display = "inline-block";
                document.getElementById("seat_number_error1").textContent = "Must be less than 151";
                document.getElementById("user_phone_number1").scrollIntoView();
            }
        } else {
            isSeatNumberValid = 0;
            document.getElementById("seat_number1").style.borderColor = "#ff8784";
            document.getElementById("seat_number_error1").style.display = "inline-block";
            document.getElementById("seat_number_error1").textContent = "Must be less than 151";
            document.getElementById("user_phone_number1").scrollIntoView();
        }


        // Validating email           
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(userEmail)) {
            isUserEmailValid = 1;
        } else {
            isUserEmailValid = 0;
            document.getElementById("user_email1").style.borderColor = "#ff8784";
            document.getElementById("user_email_error1").style.display = "inline-block";
            document.getElementById("user_email_error1").textContent = "Email is not valid";
            document.getElementById("user_phone_number1").scrollIntoView();
        }

        // validating pnr
        if (userPnr.length === 10) {
            isUserPnrValid = 1;
        } else {
            isUserPnrValid = 0;
            document.getElementById("user_pnr1").style.borderColor = "#ff8784";
            document.getElementById("user_pnr_error1").style.display = "inline-block";
            document.getElementById("user_pnr_error1").textContent = "PNR is not vaild";
            document.getElementById("user_pnr_error1").scrollIntoView();
        }

        // If all values are filled and valid
        if ((isUserPhoneEntered === 1)
            && (isUserNameEntered === 1)
            && (isSeatNumberEntered === 1)
            && (isCoachNumberEntered === 1)
            && (isUserEmailEntered === 1)
            && (isUserPnrEntered === 1)
            && (isUserPhoneValid === 1)
            && (isUserNameValid === 1)
            && (isSeatNumberValid === 1)
            && (isCoachNumberValid === 1)
            && (isUserEmailValid === 1)
            && (isUserPhoneValid === 1)
            && (isUserPnrValid === 1)) {
            let btn = document.getElementById("proceednext");
            btn.className = "loading";

            if (this.props.price.to_pay > this.props.stations[0].bulk_limt) {
                this.setState({ bulkOrder: true });
                this.props.bulkOrderStart();
            }
            if (this.state.bulkOrder === false && this.props.price.min_order_status != 0) {
                await this.props.checkLeadTime();
                const leadTime = await this.props.leadTime;
                if (leadTime.status === 1) {
                    document.getElementById("proceednext").disabled = true;
                    this.myFunction();
                } else {
                    document.getElementById("proceednext").disabled = true;
                    // setTimeout(function() {
                    //     document.getElementById("proceednext").classList.remove("loading");
                    // }, 5000);
                }
            } else {
                let btn = document.getElementById("proceednext");
                btn.className = btn.className.replace("loading", "");
                var y = document.getElementById("minordertoast");
                y.className = "addontoast show";
                setTimeout(function () { y.className = y.className.replace("show", ""); }, 3000);
            }
        }

    }

    renderSwitch(param) {
        switch (param) {
            case 'Journey Details':
                return 'Next: Select Train';
            case 'Station Details':
                return 'Next: Select Station';
            case 'Station List':
                return 'Next: Review Cart';
            case 'All Station List':
                return 'Next: Review Cart';
            case 'Review Page':
                return 'Next: Place Order';
            default:
                return param;
        }
    }

    render() {
        const { cartTotal, totalItem, toggleCart, position, pagename, checkAddOn, stations, selectedStation, price, leadTime } = this.props;

        return (

            <div id='sticky-wrapper' className={`${(pagename !== 'Journey Details' && pagename !== 'Station Details') ? 'station ' : ''}sticky-wrapper ${totalItem === 0 ? '' : 'active'}`}>

                {(pagename === 'Journey Details') &&
                    <Cart />
                }

                <JourneyDetails />

                {(leadTime && leadTime.status === 0) &&
                    <div className="popup-timeout">
                        <div className="modal-body">
                            <img src={timeout} className="timeout-img" alt="timeout"></img>
                            <h3>Time Out!</h3>
                            <p>Sorry! Your can't order food from the selected station now.</p>
                            <Link className="try-another-station" to={'/m/buy-food-in-train/station-details'+this.props.urlData} >TRy ANOTHER STATION</Link>
                            <a href="/m/buy-food-in-train" className="go-home">go home</a>
                        </div>
                    </div>
                }

                {(this.state.bulkOrder === true) &&
                    <PriceLimit />
                }

                {checkAddOn === true &&
                    <div id="addontoast" className="addontoast">Please add main course!!</div>
                }
                {price.min_order_status === 0 &&
                    <div id="minordertoast" className="addontoast">{price.msg}</div>
                }
                <div id="noItemToast" className="addontoast">Please add items!!</div>
                <div id="stationontoast" className="addontoast">{stations.msg}</div>
                {(stations.msg && pagename === 'Station Details') &&
                    this.handleStationToast(this.props)
                }

                <div id="the-sticky-container" className='sticky-container'>
                    {pagename === 'Review Page' &&
                        <div className='left-contents' id="reviewpay">
                            <div className="sticky-pay">You Pay</div>
                            <div className="sticky-total">₹{price.to_pay}</div>
                        </div>
                    }
                    {pagename !== 'Review Page' &&
                        <div id="stationpay" onClick={() => pagename !== "All Station List"?toggleCart():''}>
                            <div className="sticky-cart-container">
                                <p className="carttotal">₹{cartTotal}</p>
                                <div className="devide"></div>

                                {totalItem &&
                                    <p className="cartlength sticky-p">{totalItem}</p>
                                }

                                <p className="cartlength">&nbsp;Item(s)
                                    {pagename === 'Journey Details' &&
                                        <i id="cartarrow" className={`${position ? 'stick-rotate' : ''} fas fa-chevron-up fa-lg`} ></i>
                                    }
                                </p>

                            </div>
                            <p className="additional" >Additional Charges Apply</p>

                        </div>
                    }
                    <div className='right-content'>
                        <button id="proceednext"
                            onClick={() => { this.proceed(); window.navigator.vibrate(50); }}
                        ><span className="sticky-proceed-button">
                                PROCEED
                            </span><span className="loader-wrap"><img src={loader} className="loader-icon" alt="loading"></img></span>
                            <br />
                            {pagename &&
                                <span>{this.renderSwitch(pagename)}</span>}

                            {selectedStation && selectedStation.slotTime && (selectedStation.slotTime !== '') &&
                                <span>
                                    Slot closes in&nbsp;
                                    <span style={{ fontWeight: "600" }}>
                                        {selectedStation.slotTime}
                                    </span>
                                </span>
                            }

                        </button>
                    </div>
                </div>
            </div >
        )
    }
}
const mapStateToProps = createStructuredSelector({
    cartTotal: selectCartTotal,
    price: selectPrice,
    totalItem: selectCartItemsCount,
    position: selectToggle,
    pagename: selectPageName,
    checkAddOn: selectAddOnCheck,
    trainNo: selectTrainNo,
    boardingStation: selectBoardingStation,
    boardingDate: selectBoardingDate,
    pnr: selectPnr,
    stations: selectStations,
    selectedStation: selectStation,
    leadTime: selectleadTime,
    urlData: selectUrlData
})

const mapDispatchToProps = dispatch => ({
    toggleCart: () => dispatch(ToggleCart()),
    addonCheck: () => dispatch(actionAddonCheck()),
    setPage: (page) => dispatch(setPageName(page)),
    getStationDetails: () => dispatch(setStationsDetailStart()),
    setName: name => dispatch(setName(name)),
    setPhoneNo: phoneNo => dispatch(setPhoneNo(phoneNo)),
    setPnr: pnr => dispatch(setPnr(pnr)),
    setSeatNo: seatNo => dispatch(setSeatNumber(seatNo)),
    setCoachNo: coachNo => dispatch(setCoachNumber(coachNo)),
    setEmail: email => dispatch(setEmailId(email)),
    checkLeadTime: () => dispatch(checkLeadTimeStart()),
    setStationDetails: data => dispatch(setStationsDetailSuccess(data)),
    setVersion: version => dispatch(setVersion(version)),
    bulkOrderStart: () => dispatch(setBulkOrderStart()),
})

export default connect(mapStateToProps, mapDispatchToProps)(sticky);